<template>
  <div>
    <v-row class="px-4 product-row">
      <!-- <pre>{{ items?.bill.purchase_order[0].contact.display_name }}</pre> -->
      <v-col md="12" class="px-0 py-0">
        <v-expansion-panels elevation="1" v-model="panel" multiple>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <h5 class="my-0 px-0 py-0">SUPPLIER bthrust company</h5>
            </v-expansion-panel-header>
            <v-divider class="my-0"></v-divider>
            <v-expansion-panel-content class="px-0 py-0">
              <v-row class="">
                <v-col md="3">
                  <h6 class="blue--text text--darken-4 text-h6">Supplier Detail</h6>
                  <div>
                    <v-icon color="disabled" size="18" class="me-1">mdi-account</v-icon>
                    <span>{{ items?.bill?.supplier?.display_name }}</span>
                  </div>
                  <div>
                    <v-icon color="disabled" size="18" class="me-1">mdi-email</v-icon>
                    <span v-if="items?.bill?.supplier?.company_email">{{ items?.bill?.supplier?.company_email }}</span>
                    <span v-else>No Email</span>

                  </div>
                  <div>
                    <v-icon color="disabled" size="18" class="me-1">mdi-phone</v-icon>
                    <span v-if="items?.bill?.supplier?.company_phone">{{ items?.bill?.supplier?.company_phone }}</span>
                    <span v-else>No Phone</span>

                  </div>
                </v-col>
                <v-col md="3">
                  <h6 class="blue--text text--darken-4 text-h6">Contact Person</h6>
                  <div>
                    <v-icon color="disabled" size="18" class="me-1">mdi-account</v-icon>
                    <span>{{ items?.bill.purchase_order[0]?.contact?.display_name }}</span>
                  </div>
                  <div>
                    <v-icon color="disabled" size="18" class="me-1">mdi-email</v-icon>
                    <span v-if="items?.bill.purchase_order[0]?.contact?.primary_email">{{ items?.bill.purchase_order[0]?.contact?.primary_email }}</span>
                    <span v-else>No Email</span>

                  </div>
                  <div>
                    <v-icon color="disabled" size="18" class="me-1">mdi-phone</v-icon>
                    <span v-if="items?.bill.purchase_order[0]?.contact?.primary_phone ">{{ items?.bill.purchase_order[0]?.contact?.primary_phone }}</span>
                    <span v-else>No Phone</span>

                  </div>
                </v-col>
                <v-col md="3">
                  <h6 class="blue--text text--darken-4 text-h6">Address</h6>
                  <div>
                    <div class="d-flex">
                      <div>
                        <v-icon color="disabled" size="18" class="me-1">mdi-map</v-icon>
                      </div>
                      <span
                        >{{ items?.bill?.supplier?.country }}<br />
                        {{ items?.bill?.supplier.address_line_1 }}<br />
                        {{ items?.bill?.supplier.address_line_2 }}<br />
                        {{ items?.bill?.supplier.country }}<br />
                        {{ items?.bill?.supplier.postal_code }}</span
                      >
                    </div>
                  </div>
                </v-col>
                <v-col md="3"> </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "purchase-order-detail",
  data() {
    return {
      panel: [0],
      // product: {
      // }
      purchaseOrder: [{}],
    };
  },
  props: {
    items: {
      type: Object,
      default: () => {
        return [];
      },
    },
  },
};
</script>

<style scoped>
.th {
  font-size: 13px !important;
}

.product-row {
  margin: 0 !important;
}
</style>
